import React from 'react';
import RCTable from 'rc-table';
import { Col, Container, Pagination, Row } from 'react-bootstrap';

import { randomInteger } from 'utils';
import HeaderCell from './components/HeaderCell';
import Table from './components/Table';

import { usePagination, useColumns } from './hooks';
import { RCTableType, GridProps } from './interfaces';

const withDataGridTable = (TableComponent: RCTableType) => (props: GridProps) => {
  const columns = useColumns(props);
  const pagination = usePagination(props);

  const handlePaginationItemClick = (pageIndex: number) => {
    if (props.onPageChange && props.pageSize && pageIndex !== pagination.activePageIndex) {
      props.onPageChange({
        skip: pageIndex * props.pageSize,
        pageSize: props.pageSize,
      });
    }
  };

  return (
    <React.Fragment>
      <TableComponent
        columns={columns}
        key={randomInteger(0, 100)}
        emptyText=""
        components={{
          table: Table,
          header: {
            cell: HeaderCell,
          },
        }}
        {...props}
      />
      {props.pageable && pagination.pagesItems.length > 0 && (
        <Container fluid>
          <Row className="mt-2">
            <Col>
              <Pagination>
                <Pagination.First onClick={() => handlePaginationItemClick(0)} />
                {pagination.pagesItems.map((item: number) => {
                  if (item === 0.111) {
                    return <Pagination.Ellipsis key={item} />;
                  }
                  return (
                    <Pagination.Item
                      key={`pagination_${item}`}
                      active={item === pagination.activePageIndex}
                      onClick={() => handlePaginationItemClick(item)}
                    >
                      {item + 1}
                    </Pagination.Item>
                  );
                })}
                <Pagination.Last onClick={() => handlePaginationItemClick(pagination.pagesCount - 1)} />
              </Pagination>
            </Col>
          </Row>
        </Container>
      )}
    </React.Fragment>
  );
};

export const DataGrid = withDataGridTable(RCTable);
